import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import mdnSwapAction from '../../redux/swap/actions';
import { useDispatch, useSelector } from "react-redux";
import ToastAlert from "../../components/utils/ToastAlert";
import CardLayout from "../../components/utils/CardLayout";

const { mdnswap, resetMessage } = mdnSwapAction;
const MDNSwap = () => {
  const dispatch = useDispatch();
  const { mdnSwapMessage, mdnSwapLoading, mdnSwapError, } = useSelector((state) => state.swap);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: { serialNumber: "", msisdn: "", zipCode: "", },
  });

  useEffect(()=>{
    return(()=>{
      dispatch(resetMessage())
    })
  },[])

  const onSubmit = (data) => {
    dispatch(mdnswap({
      data: {
        serialNumber: data?.serialNumber,
        msisdn: data?.msisdn,
        zipCode: data?.zipCode,
      },
    }))
  };
  const handleReset = () => {
    reset();
    dispatch(resetMessage())
  };
  useEffect(() => {
    if (mdnSwapMessage) {
      ToastAlert({
        type: "success",
        text: mdnSwapMessage,
      })
      handleReset();
    }
    if (mdnSwapError) {
      ToastAlert({
        type: "error",
        text: mdnSwapError,
      })
    }
  }, [mdnSwapMessage, mdnSwapError])

  return (
    <CardLayout
      title={<> MSISDN Swap</>}
      icon="fas fa-exchange-alt " >
      <div className="row">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit(onSubmit)} noValidate >
            <div className="row">
              {/* Serial Number */}
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  Serial Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.serialNumber ? "is-invalid" : ""
                    }`}
                  placeholder="Serial Number"
                  {...register("serialNumber", {
                    required: "Serial number is required",
                    pattern: {
                      value: /^[0-9]{19}$/,
                      message: "Serial number must be exactly 19 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 19);
                  }}
                />

                <div className="invalid-feedback"> {errors.serialNumber?.message} </div>
              </div>

              {/* MDN Number */}
              <div className="col-lg-3 mb-2" >
                <label className="form-label fw-semibold">
                  MSISDN <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.msisdn ? "is-invalid" : ""}`}
                  placeholder="MSISDN"
                   maxLength={10}
                  {...register("msisdn", {
                    required: "MSISDN is required",
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                />
                <div className="invalid-feedback"> {errors.msisdn?.message} </div>
              </div>

              {/* Zip Code */}
              <div className="col-lg-3 mb-2"
              >
                <label className="form-label fw-semibold">
                  ZIP Code <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.zipCode ? "is-invalid" : ""
                    }`}
                  placeholder="ZIP Code"
                  {...register("zipCode", {
                    required: "ZIP code is required",
                  })}
                />

                <div className="invalid-feedback"> {errors.zipCode?.message} </div>
              </div>

              {/* Submit */}
              <div className="col-md-3 d-flex align-items-end" style={{ height: '70px' }}>
                <div className="d-flex gap-3">
                  <Button
                    title={mdnSwapLoading ? 'Processing...' : "Swap MSISDN "}
                    buttonType="submit"
                    variant="primary"
                    disabled={mdnSwapLoading}
                    icon={<i className="fas fa-exchange-alt menu-icon me-2"></i>}
                  />
                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    icon={<i className="ri-refresh-line me-2"></i>}
                    onClick={handleReset}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};

export default MDNSwap;
